import type { FunctionComponent } from "react";
import { graphql, useFragment } from "react-relay";

import type { contentSeriesShortLabelContent$key } from "scmp-app/queries/__generated__/contentSeriesShortLabelContent.graphql";

import { SeriesShortLabelLink } from "./styles";

type Props = {
  className?: string;
  format?: string;
  reference: contentSeriesShortLabelContent$key;
};

export const ContentSeriesShortLabel: FunctionComponent<Props> = ({
  className,
  reference: reference_,
}) => {
  const content = useFragment(
    graphql`
      fragment contentSeriesShortLabelContent on Content {
        ... on Article {
          seriesShortLabel
          ...entityLink
          seriesContainer {
            ...entityLink
            seriesShortLabel
          }
        }
      }
    `,
    reference_,
  );

  if (!content.seriesContainer?.seriesShortLabel && !content.seriesShortLabel) return null;

  const linkReference = content.seriesContainer ?? content;
  const shortLabel = content.seriesContainer?.seriesShortLabel ?? content.seriesShortLabel;

  return (
    <SeriesShortLabelLink className={className} reference={linkReference}>
      SERIES: {shortLabel}
    </SeriesShortLabelLink>
  );
};

ContentSeriesShortLabel.displayName = "ContentSeriesShortLabel";
